import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { Button } from '@/components/ui/button';
import { Shield, Check, X } from 'lucide-react';

const CONSENT_COOKIE_NAME = 'site_consent';

const ConsentBanner = ({ onConsentChange }) => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = Cookies.get(CONSENT_COOKIE_NAME);
    if (!consent) {
      setShowBanner(true);
    } else {
      // Notify parent of existing consent
      if (onConsentChange) {
        onConsentChange(consent === 'true');
      }
    }
  }, [onConsentChange]);

  const handleAccept = () => {
    Cookies.set(CONSENT_COOKIE_NAME, 'true', { expires: 365 });
    setShowBanner(false);
    if (onConsentChange) onConsentChange(true);
  };

  const handleDecline = () => {
    Cookies.set(CONSENT_COOKIE_NAME, 'false', { expires: 365 });
    setShowBanner(false);
    if (onConsentChange) onConsentChange(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-4 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-t border-border shadow-2xl animate-in slide-in-from-bottom-full duration-500">
      <div className="container max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-start gap-4 text-left">
          <div className="p-2 rounded-full bg-primary/10 text-primary mt-1 hidden sm:block">
            <Shield className="w-5 h-5" />
          </div>
          <div className="space-y-1">
            <h3 className="font-semibold text-foreground">We value your privacy</h3>
            <p className="text-sm text-muted-foreground max-w-2xl">
              We use cookies and analytics to enhance your experience, analyze site traffic, and personalize content. 
              By clicking "Accept", you consent to our use of these technologies. 
              You can withdraw your consent at any time.
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3 w-full sm:w-auto">
          <Button variant="outline" size="sm" onClick={handleDecline} className="flex-1 sm:flex-none">
            <X className="w-4 h-4 mr-2" />
            Decline
          </Button>
          <Button size="sm" onClick={handleAccept} className="flex-1 sm:flex-none">
            <Check className="w-4 h-4 mr-2" />
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;
